/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useContext } from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import Lozenge from '@atlaskit/lozenge';
import { Text } from '@atlaskit/primitives/compiled';

import type { InvitedAppShortcutAllowedApsKey } from '../../../../common/types';
import { InvitedAppShortcutsContext } from '../../../../controllers/invited-app-shortcuts-context';

import AnimatedLozenge from './animated-lozenge';

interface InvitedAppShortcutLabelProps {
	apsKey: InvitedAppShortcutAllowedApsKey;
	label: string;
}

const styles = cssMap({
	container: {
		display: 'grid',
		gridTemplateColumns: 'auto 1fr',
		alignItems: 'center',
		width: '100%',
	},
	lozengeContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
		minWidth: '0px',
	},
});

export const InvitedAppShortcutLabel = ({ label, apsKey }: InvitedAppShortcutLabelProps) => {
	const { impressedProducts } = useContext(InvitedAppShortcutsContext);
	// TODO: replace the text with i18n messages from the PR https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/270365
	const lozengeText = 'Invited';

	return (
		<div css={styles.container}>
			<Text>{label}</Text>
			<div css={styles.lozengeContainer}>
				{impressedProducts[apsKey] ? (
					<Lozenge appearance="inprogress">{lozengeText}</Lozenge>
				) : (
					<AnimatedLozenge appearance="new">{lozengeText}</AnimatedLozenge>
				)}
			</div>
		</div>
	);
};
